<template>
	<div class="form-page">

		<div class="pad-20">
			<el-tabs v-model="type" @tab-click="handleClick">
				<el-tab-pane :label="$t('市价')" name="1"></el-tab-pane>
				<el-tab-pane :label="$t('现价')" name="2"></el-tab-pane>
			</el-tabs>

			<div class="form-div dis-fle ali-cen">
				<div class="flex-1">
					<div class="form-item">
						<el-input v-model="zForm.limit_price" :placeholder="type == 1 ? $t('以当前市场最优价格下单') : $t('请输入')"
							:disabled="type == 1" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('价格(USDT)') }}</span>
						</el-input>
					</div>
					<div class="form-item">
						<el-input v-model="zForm.amount" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('成交额(USDT)') }}</span>
						</el-input>
					</div>
					<!-- <div class="form-item">
						<el-input v-model="zForm.pay_password" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('资金密码') }}</span>
						</el-input>
					</div> -->
					<div class="form-item slider-div">
						<el-slider v-model="zForm.slider" :marks="marks"></el-slider>
					</div>
					<div class="form-item">
						<div class="but" @click="submit(1)">{{ $t('买入') }}</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('可用') }}</span>
							<span class="value">{{ money }} USDT</span>
						</div>
						<div class="right">
							<span class="label"></span>
							<span class="value"></span>
						</div>
					</div>
				</div>

				<div class="flex-1" style="margin-left: 20px;">
					<div class="form-item">
						<el-input v-model="dForm.limit_price" :placeholder="type == 1 ? $t('以当前市场最优价格下单') : $t('请输入')"
							:disabled="type == 1" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('价格(USDT)') }}</span>
						</el-input>
					</div>
					<div class="form-item">
						<el-input v-model="dForm.amount" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('成交额(USDT)') }}</span>
						</el-input>
					</div>
					<!-- <div class="form-item">
						<el-input v-model="dForm.pay_password" :placeholder="$t('请输入')" size="medium">
							<span slot="prefix" class="slot-prepend txt-14">{{ $t('资金密码') }}</span>
						</el-input>
					</div> -->
					<div class="form-item slider-div">
						<el-slider v-model="dForm.slider" :marks="marks"></el-slider>
					</div>
					<div class="form-item">
						<div class="but but1" @click="submit(2)">{{ $t('卖出') }}</div>
					</div>
					<div class="form-item dis-fle ali-cen jus-bet txt-14">
						<div class="left">
							<span class="label">{{ $t('可用') }}</span>
							<span class="value">{{ money }} USDT</span>
						</div>
						<div class="right">
							<span class="label"></span>
							<span class="value"></span>
						</div>
					</div>
				</div>
			</div>

			<div class="tip-div">
				<div class="title txt-16">{{ intro.title }}</div>
				<p v-html="intro.content"></p>
			</div>
		</div>
	</div>
</template>

<script>

import { post } from '@/http/request'
import apis from '@/http/api'

class FormData {
	constructor() {
		// product_id 产品id 
		// direction 1 = 买, 2 = 卖 
		// amount 下单金额 
		// limit_price 限价购买价 
		// type 1 = 市价, 2 = 限价
		this.slider = 0;
		this.product_id = "";
		this.direction = "";
		this.limit_price = "";
		this.amount = "";
		this.type = "";
		this.pay_password = "";
	}
}
export default {
	props: {
		productInfo: {
			type: Object,
			default: () => {
				return {}
			}
		},
		money: {
			type: Number,
			default: 0
		},
	},
	computed: {
		intro() {
			return this.productInfo.intro_spot || {}
		},
	},
	watch: {
		'productInfo.id'() {
			this.zForm = new FormData()
			this.dForm = new FormData()
		}
	},
	data() {
		return {
			type: '1',

			zForm: new FormData(),
			dForm: new FormData(),

			marks: {
				0: '0%',
				25: '25%',
				50: '50%',
				75: '75%',
				100: '100%',
				// 75: {
				//   style: {
				//     color: '#1989FA'
				//   },
				//   label: this.$createElement('strong', '50%')
				// }
			}
		};
	},
	methods: {
		handleClick() {
			this.zForm.limit_price = ''
			this.dForm.limit_price = ''
		},

		/**
		 * direction 1涨 2跌
		 */
		submit(direction) {
			let formData = this.zForm
			if (direction == 2) {
				formData = this.dForm
			}
			post(apis.spotOrderSubmit, {
				...formData,
				direction,
				type: this.type,
				product_id: this.productInfo.id,
				quantity: formData.amount,

			}).then(res => {
				if (res.code != 1) return
				this.$notify.success(res.msg)
				this.$emit('modify')
				this.$emit('initList')

				if (direction == 1) {
					this.zForm = new FormData()
				} else if (direction == 2) {
					this.dForm = new FormData()
				}
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.form-page {

	.tip-div {
		margin-top: 16px;
		border-top: 1px solid #31323f;

		.title {
			padding: 16px 0px;
		}

		p {
			font-size: 14px;
			color: #888;
			margin: 0px;
		}
	}

	.form-div {
		.form-item {
			margin-bottom: 10px;

			&.slider-div {
				margin-bottom: 32px;
			}

			.but {
				margin: 22px 0;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
				background-color: #00f0ff;
				color: #000;
				line-height: 46px;
				font-size: 16px;
				border-radius: 30px;

				&.but1 {
					background: #ff4834;
				}
			}

			.label {
				color: #888;
				margin-right: 10px;
			}

			::v-deep .el-input-group__prepend {
				background-color: #ffffff00;
			}

			::v-deep .el-input__inner {
				text-align: right;
				height: 44px;
				line-height: 44px;
				padding-left: 130px;
			}

			.slot-prepend {
				color: #888;
				display: inline-block;
				width: 130px;
				// padding-left: 10px;
				height: 44px;
				line-height: 44px;
			}

			::v-deep .el-slider {
				.el-slider__bar {
					background-color: #409eff;
				}

				.el-slider__button {
					border: 2px solid #409eff;
					background-color: #fff;
				}

				.el-slider__stop {
					background-color: #fff;
				}

				.el-slider__runway {
					background-color: #2e3244;
				}
			}
		}
	}
}
</style>